import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  createSearchResultListItemExtension,
  SearchResultListItemExtensionProps,
} from '@backstage/plugin-search-react';
import { rootRouteRef, feedbackRouteRef, athSeRouteRef, engineerPerformanceRouteRef } from './routes';
import { Sev2API, sev2ApiRef } from './api/Sev2Api';
import { GiteaAPI, giteaApiRef } from './api/GiteaApi';
import { AiAPI, aiApiRef } from './api/AiApi';
import { TaskSearchResultListItemProps } from './components/TaskSearchResultListItem';
import { GoogleApi, googleApi } from './api/GoogleApi';


export const sev2Plugin = createPlugin({
  id: 'sev2',
  routes: {
    root: rootRouteRef,
    feedback: feedbackRouteRef,
  },
  apis: [
    createApiFactory({
      api: sev2ApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, configApi, fetchApi }) => {
        return new Sev2API({
          discoveryApi,
          configApi,
          fetchApi,
        });
      },
    }),
    createApiFactory({
      api: aiApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, configApi, fetchApi }) => {
        return new AiAPI({
          discoveryApi,
          configApi,
          fetchApi,
        });
      },
    }),
    createApiFactory({
      api: googleApi,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, configApi, fetchApi }) => {
        return new GoogleApi({
          discoveryApi,
          configApi,
          fetchApi,
        });
      },
    }),
  ],
});


export const Sev2BoardPage = sev2Plugin.provide(
  createRoutableExtension({
    name: 'Sev2BoardPage',
    component: () =>
      import('./components/WrapperComponent').then(m => m.WrapperComponent),
    mountPoint: rootRouteRef,
  }),
);

export const FeedbackPage = sev2Plugin.provide(
  createRoutableExtension({
    name: 'FeedbackPage',
    component: () =>
      import(
        './components/Sev2BoardComponent/ClientFeedback/FeedbackPage'
      ).then(m => m.FeedbackPage),
    mountPoint: feedbackRouteRef,
  }),
);

export const AthSePage = sev2Plugin.provide(
  createRoutableExtension({
    name: 'AthSePage',
    component: () =>
      import('./components/ScoreBoard/AthSePage').then(m => m.AthSePage),
    mountPoint: athSeRouteRef,
  }),
);

export const EngineerPerformanceComponent = sev2Plugin.provide(
  createRoutableExtension({
    name: 'EngineerPerformanceComponent',
    component: () => import('./components/EngineerPerformanceComponent/EngineerPerformanceComponent').then(m => m.default),
    mountPoint: engineerPerformanceRouteRef,
  }),
);

export const RejectionSummaryComponent = sev2Plugin.provide(
  createRoutableExtension({
    name: 'RejectionSummaryComponent',
    component: () => import('./components/RejectionSummaryComponent/RejectionSummaryComponent').then(m => m.default),
    mountPoint: engineerPerformanceRouteRef,
  }),
);

export const giteaPlugin = createPlugin({
  id: 'gitea',
  apis: [
    createApiFactory({
      api: giteaApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, configApi, fetchApi }) => {
        return new GiteaAPI({
          discoveryApi,
          configApi,
          fetchApi,
        });
      },
    }),
  ],
});



export const TaskSearchResultListItem: (
  props: SearchResultListItemExtensionProps<TaskSearchResultListItemProps>,
) => JSX.Element | null = sev2Plugin.provide(
  createSearchResultListItemExtension({
    name: 'TaskSearchResultListItem',
    component: () =>
      import('./components/TaskSearchResultListItem').then(
        m => m.TaskSearchResultListItem,
      ),
  }),
);
